define([], ()=> {
    return [()=> {
        return {
            checkSessionUUID: (submissionDTO, deferred)=> {
                if (submissionDTO === undefined || submissionDTO.sessionUUID === null || submissionDTO.sessionUUID === '') { // If a session UUID wasn't created, reject with an error message
                    return deferred.reject('Error creating quote');
                }
            },
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/services/ErrorHandlingService.js